/**
 * The query of the release page with the asset of the open viewer (`?asset=<uuid>[&rev=<n>]`), or
 * without it (`uuid` null). Every other query value stays. A refresh of the page opens the viewer
 * again from this value (`useAssetDeepLink`).
 */
export function withViewerAsset(search: string, uuid: string | null, revision?: number): string {
  const params = new URLSearchParams(search);
  params.delete('asset');
  params.delete('rev');
  if (uuid !== null) {
    params.set('asset', uuid);
    if (revision !== undefined) {
      params.set('rev', String(revision));
    }
  }
  const query = params.toString();
  return query === '' ? '' : `?${query}`;
}
